import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiLocalSearch2Component } from './fi-local-search2.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FiHighlightModule } from '@fi-shared/highlight';
import { FiTag2Module } from '@fi-shared/fi-tag2/fi-tag2.module';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiLocalSearch2HelperService } from './fi-local-search2-helper.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        MatAutocompleteModule,
        FiHighlightModule,
        FiTag2Module,
        MatButtonModule,
        MatChipsModule,
        MatInputModule,
        FiAppTextSharedModule,
        SelectSearchModule,
    ],
    declarations: [FiLocalSearch2Component],
    providers: [FiLocalSearch2HelperService],
    exports: [FiLocalSearch2Component],
})
export class FiLocalSearch2Module {}
